module.exports = __webpack_public_path__ + "img/base_patrimoine_historique.3592dcac.svg";